import React from 'react';
import { useTranslation } from 'react-i18next';

const StatusCard = ({ title, children, empty = false, highlight = false }) => {
    const { t } = useTranslation();
    return (
        <div style={{
            backgroundColor: highlight ? 'rgba(59, 130, 246, 0.08)' : 'rgba(255, 255, 255, 0.05)',
            borderRadius: '16px',
            padding: '1.5rem',
            border: highlight ? '1px solid rgba(59, 130, 246, 0.4)' : '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: highlight ? '0 0 20px rgba(59, 130, 246, 0.1)' : 'none',
            textAlign: 'center',
        }}>
            <h3 style={{
                color: '#94a3b8',
                fontSize: '1rem',
                marginBottom: '1rem',
            }}>{title}</h3>

            {empty ? (
                <div style={{ color: '#64748b', fontStyle: 'italic' }}>{t('mypage.results.no_record')}</div>
            ) : (
                children
            )}
        </div>
    );
};

export default StatusCard;
